import {combineReducers} from 'redux';
import user from './user.reducer';
import login from './login.reducer';
import register from './register.reducer';
import fileImport from './fileImportStatus.reducer';

const authReducers = combineReducers({
    user,
    login,
    register,
    fileImport
});

export default authReducers;